import React, { useEffect, useMemo, useState, forwardRef } from 'react';
import { PagingQuery, Table, ConfigProvider } from 'tea-component';
import { sortable, SortBy } from 'tea-component/lib/table/addons/sortable';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import BasicTable from '@customComp/BasicTable';
import { tablePropsType } from './_type';
import './index.scss';
const { pageable, scrollable, autotip, columnsResizable } = Table.addons;

const SortTable = (props: any, ref) => {
  const {
    columns,
    records,
    pageConfig,
    sortConfig,
    loading,
    error,
    addonsConfig,
    isonResizeEnd=false,
    onResizeEnd,
    className='',
  }: tablePropsType = props;
  const { dblFormatMessage: tableFormatMessage, commonFormatMessage, isEn } = useDblIntl("table");
  const { sort, sortColumns, onSortChange } = sortConfig || {};
  const { pageInfo, onPageChange, total,isBackEndPaging=true, defaultPageSize } = pageConfig || {};
  const [cloneDeepColumns, setCloneDeepColumns] = useState(columns);

  // 内部直接接管外部columns,从内部同步
  useEffect(() => {
    setCloneDeepColumns(columns);
  }, [columns]);

  const pageableConfig:any = useMemo(() => {
    if(!pageConfig)  return;
    const recordLen:number = records?.length;
    // 前端分页不需要其他额外配置,tea有默认处理的分页配置。如：为pageSize默认为10，以及默认的onPagingChange进行数据的截取展示
    return isBackEndPaging ? {
      recordCount: total,
      pageSize: pageInfo?.pageSize,
      pageIndex: pageInfo?.pageIndex,
      pageSizeOptions: [10, 20, 30, 40, 50, 100, 200],
      stateTextVisible: total > defaultPageSize,
      pageSizeVisible: total > defaultPageSize,
      pageIndexVisible: total > defaultPageSize,
      jumpVisible: total > defaultPageSize,
      endJumpVisible: total > defaultPageSize,
      stateText: loading ? '' : (total > recordLen ? tableFormatMessage("total_more", { total }) : tableFormatMessage("total", { total })),
      onPagingChange: (query: PagingQuery) => {onPageChange(query)}
    } : {
      pageSize: pageInfo?.pageSize,
      pageIndex: pageInfo?.pageIndex,
      stateTextVisible: total > defaultPageSize,
      pageSizeVisible: total > defaultPageSize,
      pageIndexVisible: total > defaultPageSize,
      jumpVisible: total > defaultPageSize,
      endJumpVisible: total > defaultPageSize,
      pageSizeOptions: [10, 20, 30, 40, 50, 100, 200],
      onPagingChange: (query: PagingQuery) => {onPageChange(query)}
    };
  }, [isBackEndPaging, pageConfig]);

  // 因为表格表头、数据都是从后端拿的，所以无数据的话直接不展示表格
  return (
    <ConfigProvider locale={isEn ? "en" : "zh"}>
      <div ref={ref} className={`dbl-sort-table ${className}`}>
        <BasicTable
          columns={cloneDeepColumns}
          className={loading ? 'dbl-sort-table-loading' : ''}
          records={(error || error) ? [] : records}
          addonsConfig={addonsConfig ? addonsConfig : [
            isonResizeEnd && columnsResizable({
              onResizeEnd: (columns)=>onResizeEnd?.(columns, setCloneDeepColumns),
              minWidth: 55,
              // maxWidth: 500,
            }),
            scrollable({
              maxHeight: props.maxHeight || '100%',
              scrollToTopOnChange: true,
            }),
            pageable(pageableConfig),
            sortable({
              columns: sortColumns || [],
              // value: sort ? [sort] : [],
              value: sort || [],
              onChange: (value: SortBy[], context: any) => onSortChange?.(value, context),
            }),
            autotip({
              isLoading: loading,
              isError: error,
              emptyText: (
                <span className="dbl-loading-failed-nodata" title={commonFormatMessage("no_data")}>
                  {commonFormatMessage("no_data")}
                </span>
              ) ,
              loadingText: (
                <span className="dbl-loading-failed-nodata" title={commonFormatMessage("loading")}>
                  {commonFormatMessage("loading")}
                </span>
              ),
              errorText: (
                <span className="dbl-loading-failed-nodata" title={commonFormatMessage("load_fail")}>
                  {commonFormatMessage("load_fail")}
                </span>
              ),
            }),
          ]}
        />
      </div>
	
    </ConfigProvider>
  );
};

export default forwardRef(SortTable);
